export const WIDGETS_SDK_API_ERROR_CODES = {
  ERROR_ENCRYPTION_KEY_NOT_FOUND : 'ERROR_ENCRYPTION_KEY_NOT_FOUND'
}

export interface WidgetsSdkEncKeyPairResponse {
  aesKey : string
  iv : string
  expiryDate : number
}